export enum ProjectPurposeEnum {
    AanbestedingTender = 1 << 0,             // 1
    CertificeringBREEAM = 1 << 1,            // 2
    CertificeringGPRGebouw = 1 << 2,         // 4
    CertificeringOverig = 1 << 3,            // 8
    CSRD = 1 << 4,                           // 16
    HetNieuweNormaalHNN = 1 << 5,            // 32
    Materialenpaspoort = 1 << 6,             // 64
    Subsidie = 1 << 7,                       // 128
    StudieOnderzoek = 1 << 8,                // 256
    Variant = 1 << 9,                        // 512
    VergunningBBL = 1 << 10,                 // 1024
    Overig = 1 << 11                         // 2048
  }
  